import React, { Fragment, useEffect, useState } from 'react'
import TopHeader from '../../../../Components/TopHeader/TopHeader'
import { useNavigate } from 'react-router-dom'
import {
    Box, Button, Card, CardContent, Grid, Grid2, Tooltip, Typography, Tabs,
    Tab,
    Paper,
} from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";
import { GET_BY_ID_USER_INTERPRETER_ACTION, USER_ACCOUNT_STATUS_ACTION, USER_RATE_AND_REVIEW_ACTION } from '../../../../Redux/Slices/UserSlice/User.action';
import { GET_BY_ID_JOB_INTERPRETER_ACTION } from '../../../../Redux/Slices/InterpreterSlice/Interpreter.action';
import UserLegalDocumentTranslator from './UserLegalDocumentTranslator/UserLegalDocumentTranslator';
import UserReview from './UserReview/UserReview';
import Constant from '../../../../Utils/Constant';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { GET_ANALYTICS_ACTION } from '../../../../Redux/Slices/AnalyticsSlice/AnalyticsSlice.action';
import AddCoinAdjustmentModel from './AddCoinAdjustmentModel/AddCoinAdjustmentModel';
import AxiosInstance from '../../../../Config/AxiosInstance';
import APILIST from '../../../../Config/ApiList';
import CoinTransaction from './CoinTransaction/CoinTransaction';
import ReferralsDetails from '../InterpreterDetails/ReferralsDetails/ReferralsDetails';
const UserViewDetails = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [customerDetails, setCustomerDetails] = useState({});
    const [userLegalDocumentT, setUserLegalDocumentT] = useState([]);
    const [userReviewList, setUserReviewList] = useState([]);
    const [analyticsList, setAnalyticsList] = useState([]);
    const [userID, setUserID] = useState(null);
    const [showAddCoinModal, setShowAddCoinModal] = useState(false);
    const [coinTransactionList, setCoinTransactionList] = useState([]);
    const [activeTab, setActiveTab] = useState(0);
    const [refferalList, setReferralList] = useState([]);
    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    useEffect(() => {
        if (location?.state?.id) {
            const userId = location?.state?.id;
            setUserID(userId)
            getuserDetails(userId);
            getAnalytics(userId);
        }
    }, [location?.state?.id])
    useEffect(() => {
        if (location?.state?.id) {
            const userId = location?.state?.id;
            if (activeTab === 0) {
                getUserLegalDocumentsTranslator(userId);
            } else if (activeTab === 1) {
                getUserRateAndReview(userId);
            } else if (activeTab === 2) {
                getUserCoinTransaction(userId);
            } else if (activeTab === 3) {
                getReferrals(userId);
            }
        }
    }, [location?.state?.id, activeTab])
    const getuserDetails = async (id) => {
        try {
            setIsLoading(true);
            const result = await dispatch(GET_BY_ID_USER_INTERPRETER_ACTION(id));
            if (result && result?.payload?.s === 1) {
                setCustomerDetails(result?.payload?.r);
            } else {
                console.log("No user found");
                setCustomerDetails({});
            }
        } catch (error) {
            console.error("Error fetching user details", error);
        } finally {
            setIsLoading(false);
        }
    };
    const getUserRateAndReview = async (id) => {
        console.log('id', id);

        try {
            setIsLoading(true);
            const result = await dispatch(USER_RATE_AND_REVIEW_ACTION(id));
            console.log('result', result);

            if (result && result?.payload?.s === 1) {
                setUserReviewList(result?.payload?.r);
            } else {
                console.log("No review found");
                setUserReviewList([]);
            }
        } catch (error) {
            console.error("Error fetching review", error);
        } finally {
            setIsLoading(false);
        }
    };
    const getUserCoinTransaction = async (id) => {
        try {
            setIsLoading(true);
            const result = await AxiosInstance.get(APILIST.GET_ALL_COIN_ADJUSMENT_API, {
                params: {
                    user_id: id
                }
            });
            if (result && result?.data?.s === 1) {
                setCoinTransactionList(result?.data?.r);
            } else {
                console.log("No review found");
                setCoinTransactionList([]);
            }
        } catch (error) {
            console.error("Error fetching coin transaction", error);
        } finally {
            setIsLoading(false);
        }
    };
     const getReferrals = async (id) => {
            try {
                setIsLoading(true);
                const result = await AxiosInstance.get(APILIST.GET_REFERRALS_API, {
                    params: {
                        user_id: id
                    }
                });
                console.log('result', result);
                
                if (result && result?.data?.s === 1) {
                    setReferralList(result?.data?.r);
                } else {
                    console.log("No referral found");
                    setReferralList([]);
                }
            } catch (error) {
                console.error("Error fetching referral", error);
            } finally {
                setIsLoading(false);
            }
        };
    const getAnalytics = async (id) => {
        try {
            setIsLoading(true);
            const result = await dispatch(GET_ANALYTICS_ACTION(id));
            if (result && result?.payload?.s === 1) {
                setAnalyticsList(result?.payload?.r);
            } else {
                setAnalyticsList([]);
            }
        } catch (error) {
            console.error("Error fetching analytics", error);
        } finally {
            setIsLoading(false);
        }
    };
    const getUserLegalDocumentsTranslator = async (id) => {
        try {
            setIsLoading(true);
            const result = await dispatch(GET_BY_ID_JOB_INTERPRETER_ACTION(id));
            if (result && result?.payload?.s === 1) {
                if (result?.payload?.r) {
                    setUserLegalDocumentT(result?.payload?.r);
                } else {
                    console.log("Interpreter legal document not found.");
                    setUserLegalDocumentT([]);
                }
            } else {
                console.log("No valid response from the server.");
                setUserLegalDocumentT([]);
            }
        } catch (error) {
            console.error("Error fetching interpreter legal documents", error);
            alert("An error occurred while fetching the interpreter's legal documents.");
        } finally {
            setIsLoading(false);
        }
    };
    const handleAccountStatusChange = async (userId, status) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: status === 1 ? 'Do you want to unblock this user?' : 'Do you want to block this user?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
        });
        if (result.isConfirmed) {
            const actionResult = await dispatch(USER_ACCOUNT_STATUS_ACTION({ userId, status }));
            if (actionResult && actionResult?.payload?.s === 1) {
                getuserDetails(location?.state?.id)
                toast.success("User account status updated successfully!");
            } else {
                toast.error("Failed to update user account status.");
            }
        }
    };
    const handleAddCoinModalOpen = () => {
        setShowAddCoinModal(true)
    }
    const handleSubmitAddCoin = () => {
        setShowAddCoinModal(false);
        getuserDetails(location?.state?.id);
        getUserCoinTransaction(location?.state?.id);
    }
    return (
        <Fragment>
            <TopHeader
                title={"User Details"}
                onClick={() => navigate(-1)}
                type="button"
                showButton={false}
            />
            <Box
                sx={{
                    padding: "60px 15px 0px 15px",
                    maxWidth: { xs: "100%" },
                    margin: "0 auto",
                    width: "100%",
                }}
            >
                <Box sx={{
                    display: 'flex',
                    gap: '20px',
                    flexDirection: { xs: 'column', md: 'row' },
                }}>
                    <Box sx={{
                        maxWidth: { xs: "100%", md: '310px' },
                        width: '100%',
                    }}>
                        <Card
                            sx={{
                                background: "rgba(230, 245, 247, 1)",
                                position: "relative",
                                width: '100%'
                            }}
                        >
                            <CardContent>
                                {isLoading ? <Skeleton height={116} width={116} borderRadius={50} /> :
                                    <Box
                                        sx={{
                                            width: '116px',
                                            margin: '0 auto 30px auto'
                                        }}
                                    >
                                        {customerDetails?.profile_img ? <img
                                            src={`${Constant.BASE_URL}${customerDetails?.profile_img}`}
                                            alt="interpreter_Profile"
                                            style={{
                                                width: "116px",
                                                height: "116px",
                                                objectFit: "cover",
                                                borderRadius: "50%",
                                                objectPosition: "top",
                                            }}
                                        /> : <AccountCircleIcon sx={{ fontSize: "100px" }} />}

                                    </Box>}
                                <Box sx={{
                                    height: "calc(100vh - 240px)",
                                    overflowY: 'auto',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '100%'
                                }}>
                                    <Typography
                                        sx={{
                                            fontSize: "16px",
                                            fontWeight: "300",
                                            color: "rgba(0, 0, 0, 0.7)",
                                            textAlign: "left",
                                            width: "100%",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        Business Name
                                    </Typography>
                                    {isLoading ? <Skeleton height={20} /> : <Typography
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "rgba(8, 85, 127, 1)",
                                            textAlign: "left",
                                            width: "100%",
                                            paddingTop: "4px",
                                            textTransform: "capitalize",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        {customerDetails?.business_name
                                            ? customerDetails?.business_name
                                            : "N/A"}
                                    </Typography>}
                                    <Typography
                                        sx={{
                                            fontSize: "16px",
                                            fontWeight: "300",
                                            color: "rgba(0, 0, 0, 0.7)",
                                            textAlign: "left",
                                            width: "100%",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        Full Name
                                    </Typography>
                                    {isLoading ? <Skeleton height={20} /> : <Typography
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "rgba(8, 85, 127, 1)",
                                            textAlign: "left",
                                            width: "100%",
                                            paddingTop: "4px",
                                            textTransform: "capitalize",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        {customerDetails?.full_name
                                            ? customerDetails?.full_name
                                            : "N/A"}
                                    </Typography>}
                                    <Typography
                                        sx={{
                                            fontSize: "16px",
                                            fontWeight: "300",
                                            color: "rgba(0, 0, 0, 0.7)",
                                            textAlign: "left",
                                            width: "100%",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        Email
                                    </Typography>
                                    {isLoading ? <Skeleton height={20} /> : <Typography
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "rgba(8, 85, 127, 1)",
                                            textAlign: "left",
                                            width: "100%",
                                            paddingTop: "4px",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        {customerDetails?.email
                                            ? customerDetails?.email
                                            : "N/A"}
                                    </Typography>}
                                    <Typography
                                        sx={{
                                            fontSize: "16px",
                                            fontWeight: "300",
                                            color: "rgba(0, 0, 0, 0.7)",
                                            textAlign: "left",
                                            width: "100%",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        Mobile Number
                                    </Typography>
                                    {isLoading ? <Skeleton height={20} /> : <Typography
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "rgba(8, 85, 127, 1)",
                                            textAlign: "left",
                                            width: "100%",
                                            paddingTop: "4px",
                                            textTransform: "capitalize",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        {customerDetails?.phno
                                            ? `${customerDetails?.phno_cc} ${customerDetails?.phno}`
                                            : "N/A"}
                                    </Typography>}
                                    <Typography
                                        sx={{
                                            fontSize: "16px",
                                            fontWeight: "300",
                                            color: "rgba(0, 0, 0, 0.7)",
                                            textAlign: "left",
                                            width: "100%",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        Address
                                    </Typography>
                                    {isLoading ? <Skeleton height={20} /> : <Typography
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            color: "rgba(8, 85, 127, 1)",
                                            textAlign: "left",
                                            width: "100%",
                                            paddingTop: "4px",
                                            textTransform: "capitalize",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        {customerDetails?.address
                                            ? customerDetails?.address
                                            : "N/A"}
                                    </Typography>}
                                    {isLoading ? <Skeleton height={20} /> : <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gridGap: '10px'
                                    }}>
                                        <Tooltip title={customerDetails?.status === 1 ? "Block" : "Unblock"} key={customerDetails?.status === 1 ? "unblock" : "block"}>
                                            <Button
                                                onClick={() => handleAccountStatusChange(customerDetails?.id, customerDetails?.status === 1 ? 0 : 1)}
                                                sx={{
                                                    background: customerDetails?.status === 1 ? "rgba(229, 0, 0, 0.2)" : "#4caf50",
                                                    width: "auto",
                                                    margin: '20px auto 0 auto',
                                                    height: '40px',
                                                    textTransform: 'capitalize',
                                                    borderRadius: "4px",
                                                    textAlign: "center",
                                                    fontWeight: '400',
                                                    fontSize: '16px',
                                                    fontFamily: "Outfit",
                                                    padding: '10px 20px',
                                                    color: customerDetails?.status === 1 ? "rgba(229, 0, 0, 1)" : "#fff",
                                                    "&:hover": {
                                                        background: customerDetails?.status === 1 ? "rgba(229, 0, 0, 0.2)" : "#4caf50",
                                                    },
                                                }}
                                            >
                                                {customerDetails?.status === 1 ? "Block" : "Unblock"}
                                            </Button>
                                        </Tooltip>
                                    </Box>}
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                    <Box sx={{
                        width: 'calc(100%)',
                        height: "calc(100vh - 70px)",
                        overflowY: 'auto',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                        '&::-webkit-scrollbar': {
                            display: 'none',
                        },
                    }}>

                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{
                                    background: "rgba(148, 148, 148, 0.1)",
                                    padding: '25px 20px',
                                    borderRadius: '15px',
                                }}>
                                    <Typography sx={{
                                        color: 'rgba(8, 85, 127, 1)',
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        fontFamily: 'Outfit',
                                        textAlign: 'left'
                                    }}>{isLoading ? <Skeleton width={40} height={20} /> : analyticsList?.total_session || "--"}</Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        fontFamily: 'Outfit',
                                        textAlign: 'left'
                                    }}>Total Session</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{
                                    background: "rgba(148, 148, 148, 0.1)",
                                    padding: '25px 20px',
                                    borderRadius: '15px',
                                }}>
                                    <Typography sx={{
                                        color: 'rgba(8, 85, 127, 1)',
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        fontFamily: 'Outfit',
                                        textAlign: 'left'
                                    }}>{isLoading ? <Skeleton width={40} height={20} /> : analyticsList?.incomplete_session || "--"}</Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        fontFamily: 'Outfit',
                                        textAlign: 'left'
                                    }}>Incomplete Session</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{
                                    background: "rgba(148, 148, 148, 0.1)",
                                    padding: '25px 20px',
                                    borderRadius: '15px',
                                }}>
                                    <Typography sx={{
                                        color: 'rgba(8, 85, 127, 1)',
                                        fontSize: '18px',
                                        fontWeight: '600',
                                        fontFamily: 'Outfit',
                                        textAlign: 'left'
                                    }}>{isLoading ? <Skeleton width={40} height={20} /> : analyticsList?.rating || "--"}</Typography>
                                    <Typography sx={{
                                        fontSize: "16px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.7)",
                                        fontFamily: 'Outfit',
                                        textAlign: 'left'
                                    }}>Rating</Typography>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{
                                    background: "rgba(148, 148, 148, 0.1)",
                                    padding: '24px',
                                    borderRadius: '16px',
                                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
                                    border: '1px solid rgba(237, 242, 247, 1)',
                                    display: 'flex',
                                    gap: '12px',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    height: '100%'
                                }}>
                                    <Box>
                                        <Typography sx={{
                                            color: 'rgba(100, 116, 139, 1)',
                                            fontSize: '16px',
                                            fontWeight: '400',
                                            fontFamily: 'Outfit',
                                            mb: '4px'
                                        }}>Coin</Typography>

                                        {isLoading ? (
                                            <Skeleton width={60} height={32} />
                                        ) : (
                                            <Typography sx={{
                                                color: 'rgba(8, 85, 127, 1)',
                                                fontSize: '24px',
                                                fontWeight: '600',
                                                fontFamily: 'Outfit',
                                                lineHeight: '1.2'
                                            }}>
                                                {customerDetails?.coin || 0}
                                            </Typography>
                                        )}
                                    </Box>

                                    <Button
                                        variant="contained"
                                        onClick={handleAddCoinModalOpen}
                                        sx={{
                                            backgroundColor: '#0097B2',
                                            color: '#fff',
                                            fontFamily: 'Outfit',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            padding: '8px 16px',
                                            borderRadius: '8px',
                                            textTransform: 'capitalize',
                                            mt: 'auto',
                                            width: 'fit-content',
                                            '&:hover': {
                                                backgroundColor: '#007a91',
                                                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
                                            }
                                        }}
                                    >
                                        Add Coin
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                        <Grid2 container spacing={2}>
                            <Grid2 size={{ xs: 12 }}>
                                <Box sx={{
                                    display: 'flex',
                                    height: '100%',
                                    bgcolor: 'background.paper',
                                    paddingTop: '24px'
                                }}>
                                    <Tabs
                                        orientation="vertical"
                                        variant="scrollable"
                                        value={activeTab}
                                        onChange={handleChange}
                                        sx={{
                                            borderRight: 1,
                                            borderColor: 'divider',
                                            minWidth: 220,
                                            bgcolor: '#f8fafc',
                                            '& .MuiTab-root': {
                                                alignItems: 'flex-start',
                                                textTransform: 'none',
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                fontFamily: 'Outfit',
                                                padding: '12px 24px',
                                                position: 'relative',
                                                '&.Mui-selected': {
                                                    color: "#0097B2",
                                                    bgcolor: 'rgba(0, 151, 178, 0.08)',
                                                    '&::after': {
                                                        content: '""',
                                                        position: 'absolute',
                                                        right: 0,
                                                        top: 0,
                                                        height: '100%',
                                                        width: '4px',
                                                        bgcolor: '#0097B2'
                                                    }
                                                },
                                                '&:hover': {
                                                    bgcolor: 'rgba(0, 151, 178, 0.04)'
                                                }
                                            }
                                        }}
                                    >
                                        <Tab
                                            label="Session Details"
                                            sx={{ color: activeTab === 0 ? "#0097B2" : "inherit" }}
                                        />
                                        <Tab
                                            label="Rating & Review"
                                            sx={{ color: activeTab === 1 ? "#0097B2" : "inherit" }}
                                        />
                                        <Tab
                                            label="Coin Transaction"
                                            sx={{ color: activeTab === 2 ? "#0097B2" : "inherit" }}
                                        />
                                        <Tab
                                            label="Referrals"
                                            sx={{ color: activeTab === 3 ? "#0097B2" : "inherit" }}
                                        />
                                    </Tabs>
                                    {activeTab === 0 && (
                                        <UserLegalDocumentTranslator
                                            userLegalDocumentT={userLegalDocumentT}
                                            isLoading={isLoading}
                                        />
                                    )}
                                    {activeTab === 1 && (
                                        <UserReview
                                            userReviewList={userReviewList}
                                            isLoading={isLoading}
                                        />
                                    )}
                                    {activeTab === 2 && (
                                        <CoinTransaction
                                            coinTransactionList={coinTransactionList}
                                            isLoading={isLoading}
                                        />
                                    )}
                                    {activeTab === 3 && (
                                        <ReferralsDetails
                                            referralList={refferalList}
                                            isLoading={isLoading}
                                        />
                                    )}
                                </Box>
                            </Grid2>
                            {/* <Grid2 size={{ xs: 12, md: 4 }}>
                                <Typography
                                    variant="p"
                                    component={"p"}
                                    sx={{
                                        color: "#0097B2",
                                        fontSize: { xs: '18px', md: "20px" },
                                        fontWeight: "600",
                                        fontFamily: "Outfit",
                                        padding: '20px 0px 20px 20px'
                                    }}
                                >
                                    Session Details
                                </Typography>
                                <UserLegalDocumentTranslator
                                    userLegalDocumentT={userLegalDocumentT}
                                    isLoading={isLoading} />
                            </Grid2>
                            <Grid2 size={{ xs: 12, md: 4 }}>
                                <Typography
                                    variant="p"
                                    component={"p"}
                                    sx={{
                                        color: "#0097B2",
                                        fontSize: { xs: '18px', md: "20px" },
                                        fontWeight: "600",
                                        fontFamily: "Outfit",
                                        padding: '20px 0px 20px 20px'
                                    }}
                                >
                                    Rating & Review
                                </Typography>
                                <UserReview
                                    userReviewList={userReviewList}
                                    isLoading={isLoading}
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12, md: 4 }}>
                                <Typography
                                    variant="p"
                                    component={"p"}
                                    sx={{
                                        color: "#0097B2",
                                        fontSize: { xs: '18px', md: "20px" },
                                        fontWeight: "600",
                                        fontFamily: "Outfit",
                                        padding: '20px 0px 20px 20px'
                                    }}
                                >
                                    Coin Transaction
                                </Typography>
                                <CoinTransaction
                                    coinTransactionList={coinTransactionList}
                                    isLoading={isLoading}
                                />
                            </Grid2> */}
                        </Grid2>
                    </Box>
                </Box>
            </Box>
            <AddCoinAdjustmentModel
                open={showAddCoinModal}
                onClose={() => setShowAddCoinModal(false)}
                userId={userID}
                handleOnClose={() => setShowAddCoinModal(false)}
                handleSubmitAddCoin={handleSubmitAddCoin}
            />
        </Fragment>
    )
}

export default UserViewDetails